import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoSearchResultsWeb = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 96,
	height: 96,
	viewBox: "0 0 96 96",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M36.4511 63.5759H13.9055V26.1599H1.43994V68.8799H39.4223C38.1983 67.2719 37.1951 65.4863 36.4511 63.5759Z",
			fill: "#D6DADC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M69.1199 14.6399V19.6799H13.8527V57.3599H7.67993V14.6399H69.1199Z",
			fill: "#1952B3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M73.4399 63.8399H13.9199V19.6799H73.4399V35.4479V42.5279V63.8399Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M57.84 72.96C69.9019 72.96 79.68 63.1819 79.68 51.12C79.68 39.0581 69.9019 29.28 57.84 29.28C45.7781 29.28 36 39.0581 36 51.12C36 63.1819 45.7781 72.96 57.84 72.96Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M48.36 31.4399H18.96V43.4399H37.392C39.3744 38.1695 43.3296 33.8687 48.36 31.4399Z",
			fill: "#F4F5F6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M36 51.1201C36 49.4689 36.1872 47.8657 36.5376 46.3201H18.96V58.3201H37.2192C36.432 56.0641 36 53.6449 36 51.1201Z",
			fill: "#F4F5F6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.6207 23.0063H19.1279V24.4991H20.6207V23.0063Z",
			fill: "#232729"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.2321 23.0063H21.7393V24.4991H23.2321V23.0063Z",
			fill: "#232729"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.848 23.0063H24.3552V24.4991H25.848V23.0063Z",
			fill: "#232729"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M77.0831 66.288L76.0319 67.3392L74.2559 65.5632C77.6495 61.7088 79.7135 56.664 79.7135 51.1392C79.7135 46.3872 78.1871 41.9904 75.5999 38.4V18.72H75.1199H71.7599H52.5599V19.68H13.6799V63.84H40.0799C44.0495 69.3792 50.5343 72.9984 57.8543 72.9984C63.2447 72.9984 68.1839 71.0304 71.9999 67.7856L73.7951 69.5808L72.7439 70.632L89.6351 87.5232L93.9791 83.1792L77.0831 66.288ZM72.8351 35.2464C72.8255 35.2368 72.8111 35.2224 72.8015 35.2128C72.8159 35.2224 72.8255 35.2368 72.8351 35.2464ZM15.5999 61.92V27.84H68.3999V25.92H15.5999V21.6H52.5599V22.56H71.7599V34.2864C67.9775 31.1616 63.1295 29.28 57.8543 29.28C45.8015 29.28 35.9951 39.0864 35.9951 51.1392C35.9951 55.056 37.0367 58.7376 38.8511 61.92H15.5999ZM57.8543 69.7968C47.5679 69.7968 39.1967 61.4256 39.1967 51.1392C39.1967 40.8528 47.5679 32.4816 57.8543 32.4816C68.1407 32.4816 76.5119 40.848 76.5119 51.1392C76.5119 61.4304 68.1407 69.7968 57.8543 69.7968Z",
			fill: "#232729"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M89.6302 87.5185L72.739 70.6273L73.7902 69.5761L71.9951 67.7809C68.1791 71.0305 63.2398 72.9937 57.8494 72.9937C45.7966 72.9937 35.9903 63.1873 35.9903 51.1345C35.9903 50.2705 36.0479 49.4209 36.1439 48.5857C35.3807 50.8081 34.9583 53.1889 34.9583 55.6657C34.9583 67.7185 44.7647 77.5249 56.8175 77.5249C62.2079 77.5249 67.147 75.5569 70.963 72.3121L72.7583 74.1073L71.7071 75.1585L88.5983 92.0497L92.9423 87.7057L91.1902 85.9537L89.6302 87.5185Z",
			fill: "#D6DADC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M62.5918 42.3121C61.459 41.3617 59.8606 40.8865 57.8014 40.8865C55.7326 40.8865 54.1246 41.4001 52.9774 42.4321C51.8302 43.4641 51.2494 44.9041 51.2302 46.7521H55.915C55.9342 46.0609 56.1118 45.5089 56.4574 45.1009C56.7982 44.6929 57.2494 44.4913 57.8014 44.4913C59.0014 44.4913 59.6062 45.1873 59.6062 46.5841C59.6062 47.1553 59.4286 47.6833 59.0734 48.1585C58.7182 48.6337 58.1998 49.1569 57.5134 49.7329C56.8318 50.3041 56.3374 50.9809 56.0302 51.7633C55.7278 52.5457 55.5742 53.6113 55.5742 54.9601H59.539C59.5582 54.2593 59.6542 53.6785 59.8318 53.2225C60.0046 52.7665 60.3214 52.3201 60.7726 51.8833L62.3662 50.4001C63.043 49.7425 63.5326 49.0993 63.835 48.4705C64.1422 47.8417 64.291 47.1457 64.291 46.3777C64.2862 44.6209 63.7246 43.2673 62.5918 42.3121Z",
			fill: "#FF5100"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M57.6 57.6577C56.8608 57.6577 56.2416 57.8785 55.7472 58.3153C55.2528 58.7521 55.0032 59.3137 55.0032 60.0001C55.0032 60.6865 55.2528 61.2481 55.7472 61.6849C56.2416 62.1265 56.8608 62.3425 57.6 62.3425C58.3392 62.3425 58.9584 62.1217 59.4528 61.6849C59.9472 61.2481 60.1968 60.6817 60.1968 60.0001C60.1968 59.3137 59.9472 58.7521 59.4528 58.3153C58.9584 57.8737 58.3392 57.6577 57.6 57.6577Z",
			fill: "#FF5100"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M69.2704 9.17815L68.2522 8.15991L64.8581 11.554L65.8763 12.5723L69.2704 9.17815Z",
			fill: "#232729"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M49.474 12.5383L50.4922 11.52L47.0981 8.12591L46.0798 9.14414L49.474 12.5383Z",
			fill: "#232729"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M58.6524 4.32007H57.2124V9.60007H58.6524V4.32007Z",
			fill: "#232729"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M46.0799 86.4342L47.0981 87.4524L50.4923 84.0583L49.474 83.0401L46.0799 86.4342Z",
			fill: "#232729"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M65.8764 83.0741L64.8582 84.0923L68.2523 87.4864L69.2705 86.4682L65.8764 83.0741Z",
			fill: "#232729"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M56.6982 91.2922L58.1382 91.2922L58.1382 86.0122L56.6982 86.0122L56.6982 91.2922Z",
			fill: "#232729"
		})
	]
});
export default SvgNoSearchResultsWeb;
